import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Renderer2,
} from '@angular/core';
import { GoogleAnalyticsService } from 'ngx-google-analytics';

@Directive({
    selector: '[eaAnalyticEvent]',
    standalone: false
})
export class EaAnalyticEventDirective implements OnInit, OnDestroy {
  @Input('eaAnalyticEvent') eaAnalyticEvent: [string, string, string, number?];
  @Input('eaAnalyticEventType') eaAnalyticEventType: string = 'click';
  private dispose: Function;

  private el: HTMLInputElement;

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private googleAnalyticsService: GoogleAnalyticsService,
  ) {
    this.el = this.elementRef.nativeElement;
  }

  ngOnInit() {
    //default event type is click so `event` on click
    if (this.eaAnalyticEventType)
      this.dispose = this.renderer.listen(
        this.el,
        this.eaAnalyticEventType,
        this.event.bind(this),
      );
  }

  event(event?) {
    let [action, category, label, value] = this.eaAnalyticEvent;
    this.googleAnalyticsService.event(action, category, label, value);
  }

  ngOnDestroy(): void {
    if (this.dispose) this.dispose();
  }
}
